// src/data/specialists.js
export const INITIAL_SPECIALISTS = [
  {
    id: "spec-1",
    name: "Dr. Evelyn Reed",
    role: "Senior Physician",
    specialty: "Primary Care & Internal Medicine",
    experienceYears: 12,
    rating: 4.9,
    reviewsCount: 142,
    avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&auto=format&fit=crop&q=80",
    email: "evelyn.reed@medicare-hub.com",
    phone: "+1 (555) 234-8901",
    workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    workingHours: { start: "08:30", end: "16:30" },
    room: "Suite 101 - Building A",
    serviceIds: ["srv-1", "srv-5"]
  },
  {
    id: "spec-2",
    name: "Dr. Marcus Vance",
    role: "Chief Dental Surgeon",
    specialty: "Dentistry & Oral Health",
    experienceYears: 15,
    rating: 4.8,
    reviewsCount: 189,
    avatar: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=150&auto=format&fit=crop&q=80",
    email: "marcus.vance@medicare-hub.com",
    phone: "+1 (555) 345-6789",
    workingDays: ["Monday", "Tuesday", "Wednesday", "Friday", "Saturday"],
    workingHours: { start: "09:00", end: "17:00" },
    room: "Dental Clinic 2B",
    serviceIds: ["srv-2"]
  },
  {
    id: "spec-3",
    name: "Dr. Sophia Patel",
    role: "Consultant Cardiologist",
    specialty: "Cardiology & Vascular Medicine",
    experienceYears: 14,
    rating: 5.0,
    reviewsCount: 96,
    avatar: "https://images.unsplash.com/photo-1594824813508-bf5b274c43ba?w=150&auto=format&fit=crop&q=80",
    email: "sophia.patel@medicare-hub.com",
    phone: "+1 (555) 456-7890",
    workingDays: ["Monday", "Wednesday", "Thursday", "Friday"],
    workingHours: { start: "09:30", end: "16:00" },
    room: "Cardiac Center 4A",
    serviceIds: ["srv-3"]
  },
  {
    id: "spec-4",
    name: "Dr. Alexander Kim",
    role: "Specialist Dermatologist",
    specialty: "Dermatology & Skin Surgery",
    experienceYears: 9,
    rating: 4.9,
    reviewsCount: 118,
    avatar: "https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=150&auto=format&fit=crop&q=80",
    email: "alexander.kim@medicare-hub.com",
    phone: "+1 (555) 567-8901",
    workingDays: ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    workingHours: { start: "09:00", end: "17:30" },
    room: "Derma Lab 3C",
    serviceIds: ["srv-4"]
  },
  {
    id: "spec-5",
    name: "Dr. Maya Lindqvist",
    role: "Lead Physiotherapist",
    specialty: "Orthopedics & Sports Rehabilitation",
    experienceYears: 11,
    rating: 4.8,
    reviewsCount: 84,
    avatar: "https://images.unsplash.com/photo-1614608682850-e0d6ed316d47?w=150&auto=format&fit=crop&q=80",
    email: "maya.lindqvist@medicare-hub.com",
    phone: "+1 (555) 678-9012",
    workingDays: ["Monday", "Tuesday", "Thursday", "Friday", "Saturday"],
    workingHours: { start: "08:00", end: "15:30" },
    room: "Rehab Gym 1F",
    serviceIds: ["srv-6"]
  }
];
